import React from "react";
import { Container } from "react-bootstrap";
import "./VisionMissionSection.css";

const VisionMissionSection = () => {
  return (
    <section className="vision_mission_section">
      <Container>
        <div className="vm_grid">
          <div className="row">
            <div className="col-md-6 p-0 order-md-1 order-2">
              {/* Mission */}
              <div className="vm_box red_box">
                <div>
                  <h3>OUR MISSION</h3>
                  <p>
                    To become a trusted career transformation platform that
                    empowers individuals with industry-relevant skills,
                    real-world knowledge, and strong career outcomes in the
                    global data and technology ecosystem.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 p-0 order-md-2 order-1">
              <div className="vm_box image_box">
                <img src="/assets/images/pst_it_solution/VisionMissionSection/eye.png" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 p-0 ">
              {/* Vision */}
              <div className="vm_box image_box">
                <img
                  src="/assets/images/pst_it_solution/VisionMissionSection/arrow.png"
                  alt="Vision"
                />
              </div>
            </div>
            <div className="col-md-6 p-0 ">
              <div className="vm_box orange_box">
                <div>
                  <h3>OUR VISION</h3>
                  <p>
                    To become a trusted career transformation platform that
                    empowers individuals with industry-relevant skills,
                    real-world knowledge, and strong career outcomes in the
                    global data and technology ecosystem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default VisionMissionSection;
